/* eslint-disable */
import React from "react";
import { NavLink, useLocation, useHistory } from "react-router-dom";
// chakra imports
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Flex,
  HStack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { userController } from 'lib/user';

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let history = useHistory();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let textColor = useColorModeValue("gray.700", "white");
  let activeBg = "oklch(97% .014 254.604)";
  let activeTextColor = "oklch(48.8% .243 264.376)";

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const { userDetail } = userController();
  const { getUser } = userDetail();

  const appSettings = JSON.parse(localStorage.getItem("app_settings") || "{}");

  const isRouteVisible = (route) => {
    if (!route.roles.includes(getUser.role)) return false;
    if (route.settingRequired) {
      // default to true if setting not yet loaded
      const val = appSettings[route.settingRequired];
      if (val === false) return false;
    }
    return true;
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.type === "sidebarDropdown" && route.roles.includes(getUser.role)) {
        const isActive = route.items.some(item => activeRoute(item.path.toLowerCase()));
        return (
          <Accordion key={index} allowToggle index={isActive ? [0] : []}>
            <AccordionItem border="none">
              <AccordionButton
                px="10px"
                py="12px"
                bg="transparent"
                borderRadius="8px"
                _hover={{ bg: "transparent" }}
                _focus={{ boxShadow: "none" }}
                onClick={() => {
                  const first = route.items[0];
                  if (first) history.push(first.layout + first.path);
                }}>
                <HStack spacing={isActive ? "22px" : "26px"} flex="1" className="sidebar-item-stack">
                  <Flex w="100%" alignItems="center" justifyContent="center">
                    <Box
                      w="20px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexShrink={0}
                      color={isActive ? activeTextColor : textColor}
                      me="18px">
                      {route.icon}
                    </Box>
                    <Text
                      me="auto"
                      color={isActive ? activeTextColor : textColor}
                      fontWeight={isActive ? "bold" : "normal"}>
                      {route.name}
                    </Text>
                  </Flex>
                  <AccordionIcon color={isActive ? activeTextColor : textColor} />
                </HStack>
              </AccordionButton>
              <AccordionPanel pb={0} pt={0}>
                {route.items.map((subRoute, subIndex) => (
                  <NavLink key={subIndex} to={subRoute.layout + subRoute.path} className="sidebar-nav">
                    <HStack
                      spacing={activeRoute(subRoute.path.toLowerCase()) ? "22px" : "26px"}
                      className="sidebar-item-stack"
                      py="12px"
                      ps="10px"
                      pe="10px"
                      bg={activeRoute(subRoute.path.toLowerCase()) ? activeBg : "transparent"}
                      borderRadius="8px">
                      <Flex w="100%" alignItems="center" justifyContent="center">
                        {subRoute.icon && (
                          <Box
                            w="20px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            flexShrink={0}
                            me="18px"
                            color={activeRoute(subRoute.path.toLowerCase()) ? activeTextColor : textColor}>
                            {subRoute.icon}
                          </Box>
                        )}
                        <Text
                          me="auto"
                          fontSize="15px"
                          color={activeRoute(subRoute.path.toLowerCase()) ? activeTextColor : textColor}
                          fontWeight={activeRoute(subRoute.path.toLowerCase()) ? "bold" : "normal"}>
                          {subRoute.name}
                        </Text>
                      </Flex>
                    </HStack>
                  </NavLink>
                ))}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        );
      }
      if (route.type === "sidebarItem" && isRouteVisible(route)) {
        if (route.category) {
          return (
            <>
              <Text
                fontSize={"md"}
                color={activeColor}
                fontWeight='bold'
                mx='auto'
                ps={{
                  sm: "10px",
                  xl: "16px",
                }}
                pt='18px'
                pb='12px'
                key={index}>
                {route.name}
              </Text>
              {createLinks(route.items)}
            </>
          );
        } else if (
          route.layout === "/user" ||
          route.layout === "/auth" ||
          route.layout === "/rtl"
        ) {
          return (
            <NavLink key={index} to={route.layout + route.path} className={"sidebar-nav " + (route.class ? route.class : "")}>
              {route.icon ? (
                <Box>
                  <HStack
                    spacing={
                      activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                    }
                    className="sidebar-item-stack"
                    py='12px'
                    ps='10px'
                    pe='10px'
                    bg={
                      activeRoute(route.path.toLowerCase())
                        ? activeBg
                        : "transparent"
                    }
                    borderRadius='8px'>
                    <Flex w='100%' alignItems='center' justifyContent='center'>
                      <Box
                        w='20px'
                        display='flex'
                        alignItems='center'
                        justifyContent='center'
                        flexShrink={0}
                        color={
                          activeRoute(route.path.toLowerCase())
                            ? activeTextColor
                            : textColor
                        }
                        me='18px'>
                        {route.icon}
                      </Box>
                      <Text
                        me='auto'
                        color={
                          activeRoute(route.path.toLowerCase())
                            ? activeTextColor
                            : textColor
                        }
                        fontWeight={
                          activeRoute(route.path.toLowerCase())
                            ? "bold"
                            : "normal"
                        }>
                        {route.name}
                      </Text>
                    </Flex>
                  </HStack>
                </Box>
              ) : (
                <Box>
                  <HStack
                    spacing={
                      activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                    }
                    py='12px'
                    ps='10px'
                    pe='10px'
                    bg={
                      activeRoute(route.path.toLowerCase())
                        ? activeBg
                        : "transparent"
                    }
                    borderRadius='8px'>
                    <Text
                      me='auto'
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeTextColor
                          : inactiveColor
                      }
                      fontWeight={
                        activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                      }>
                      {route.name}
                    </Text>
                  </HStack>
                </Box>
              )}
            </NavLink>
          );
        }
      }
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
